export default __webpack_public_path__ + "static/media/navbar-logo.ef6345d1.png";